module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/px6ebY/tc-custom/9783958643185_IMGJPG_FrontCover_0.jpg",
      "alt": "This image is the cover for the book Epidicus, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Epidicus, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Dr. Artur Brückmann wurde am 8. Oktober 1928 in Singen in Deutschland geboren. Nach einer vom Zweiten Weltkrieg stark geprägten Jugend studierte er, bereits verheiratet, in Basel und später in Zürich Germanistik und Philosophie. Nach dem Studium zog er mit seiner inzwischen vierköpfigen Familie nach Davos, wo er als Gymnasiallehrer bis zu seinem gesundheitlich bedingten Ruhestand Deutsch und Philosophie unterrichtete.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Artur Brückmann\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Artur Brückmann (* 8. Oktober 1928 in Singen (Hohentwiel); † 15. Mai 2009 in Davos, Schweiz) war ein deutscher Übersetzer. Brückmanns Jugend war vom Zweiten Weltkrieg geprägt. Nach seiner Hochzeit studierte er Germanistik und Philosophie in Basel und Zürich. Nach seiner Promotion zum Dr. phil. ließ er sich mit seiner Familie in Davos nieder, wo er an dem örtlichen Gymnasium Deutsch und Philosophie unterrichtete. Nach seinem gesundheitlich bedingten Rückzug aus dem Berufsleben beschäftigte sich Brückmann ab der Mitte der 1980er Jahre mit der Übersetzung von Plautus-Komödien aus dem Lateinischen ins Deutsche. Sechs Übersetzungen konnte er fertigstellen: Asinaria, Epidicus, Mercator, Mostellaria, Pseudolus und Truculentus. Brückmann starb am 15. Mai 2009 nach langer Krankheit und hinterließ eine Frau und zwei Söhne.  (Wikipedia)")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB Ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e89f29b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0